'use client'

import React, { HTMLAttributes, useEffect, useState } from 'react'
import { Loading } from '../Loading';
import parser from 'html-react-parser';
import { HTMLReactParserOptions } from 'html-react-parser';

interface IIframeProps extends HTMLAttributes<HTMLDivElement> {
  content: string;
  iFrameHeight?: string
};

export const Iframe: React.FC<IIframeProps> = ({ content, iFrameHeight }) => {
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    parser(content, parseOption)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  
  const parseOption: HTMLReactParserOptions = {
    replace: (node, index) => {
      if (node.type === 'tag' && node.name === 'iframe' && node.children) {
        const attrs = node.attribs;

        const iframe = document.getElementById('book_transport-iframe')

        if (iframe) {
          Object.keys(attrs).map(key => {
            if (key === 'class') {
              return iframe.setAttribute(key, `${attrs[key]} ${iframe.className} w-full`)
            }
            iframe.setAttribute(key, attrs[key])
          })
        }
      }
    },
  }

  return (
    <div className='flex items-center justify-center w-full h-full'>
      <Loading isLoading={isLoading} />
      <div style={{height: iFrameHeight ? iFrameHeight : 'auto'}} className={`w-0 relative ${isLoading ? 'w-0' : 'w-full'}`}>
        <iframe id='book_transport-iframe' onLoad={() => setIsLoading(false)}></iframe>
      </div>
    </div>
  )
}
